import React from 'react';
import { Accordion, Container } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';  // Importing an icon for added visuals
// Import your custom styles

const FAQs = () => {
  return (
    <div className="container" style={{ marginTop: "100px", }}>
      <h2 className="text-center" style={{ color: "#cc9051", marginBottom: "40px" }}>Frequently Asked Questions</h2>
      <div className='row'>
        <div className='col-md-12'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            {/* Accordion Item #1 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  What types of artwork do you offer?
                </button>
              </h2>
              <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">We offer both original artwork and high-quality canvas and card prints.</div>
              </div>
            </div>

            {/* Accordion Item #2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                What are the payment options?
                </button>
              </h2>
              <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"> We accept online payments through credit cards, PayPal, and other available methods.</div>
              </div>
            </div>

            {/* Accordion Item #3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                How long does shipping take?
                </button>
              </h2>
              <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">Shipping times vary depending on your location. Please allow 7-10 days for domestic delivery and 14-25 days for international delivery.</div>
              </div>
            </div>

            {/* Accordion Item #4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                How do I care for my artwork?
                </button>
              </h2>
              <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">To ensure the longevity of your artwork, avoid exposing it to direct sunlight, moisture, or extreme temperatures.</div>
              </div>
            </div>

            {/* Accordion Item #5 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                Can I purchase artwork as a gift?
                </button>
              </h2>
              <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">Yes, our artwork makes a wonderful gift! Gift wrapping is unavailable, but you can include a personalized message with your order.</div>
              </div>
            </div>

            {/* Accordion Item #6 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingSix">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                What is the Certificate of Authenticity?
                </button>
              </h2>
              <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"> Each artwork comes with a Certificate of Authenticity, signed by the artist, verifying the artwork's genuineness and value. The certificate includes:
              <ul>
                <li>Artwork title and description</li>
                <li>Artist's signature and bio</li>
                <li>Date of creation</li>
                <li>Materials used</li>
                <li>Unique certificate number</li>
              </ul>
              This certificate ensures your artwork is a genuine piece created by the artist.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="faq-container">
        <Accordion className="faq-accordion" defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> What types of artwork do you offer?
            </Accordion.Header>
            <Accordion.Body>
              We offer both original artwork and high-quality canvas and card prints.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> What are the payment options?
            </Accordion.Header>
            <Accordion.Body>
              We accept online payments through credit cards, PayPal, and other available methods.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> How long does shipping take?
            </Accordion.Header>
            <Accordion.Body>
              Shipping times vary depending on your location. Please allow 7-10 days for domestic delivery and 14-25 days for international delivery.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> How do I care for my artwork?
            </Accordion.Header>
            <Accordion.Body>
              To ensure the longevity of your artwork, avoid exposing it to direct sunlight, moisture, or extreme temperatures.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> Can I purchase artwork as a gift?
            </Accordion.Header>
            <Accordion.Body>
              Yes, our artwork makes a wonderful gift! Gift wrapping is unavailable, but you can include a personalized message with your order.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              <FaQuestionCircle className="faq-icon" /> What is the Certificate of Authenticity?
            </Accordion.Header>
            <Accordion.Body>
              Each artwork comes with a Certificate of Authenticity, signed by the artist, verifying the artwork's genuineness and value. The certificate includes:
              <ul>
                <li>Artwork title and description</li>
                <li>Artist's signature and bio</li>
                <li>Date of creation</li>
                <li>Materials used</li>
                <li>Unique certificate number</li>
              </ul>
              This certificate ensures your artwork is a genuine piece created by the artist.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div> */}
    </div>
  );
};

export default FAQs;
